import { render, staticRenderFns } from "./index.vue?vue&type=template&id=15250cdc&scoped=true&"
import script from "./index.ts?vue&type=script&lang=ts&"
export * from "./index.ts?vue&type=script&lang=ts&"
import style0 from "./index.scss?vue&type=style&index=0&id=15250cdc&lang=scss&scoped=scoped&"
import style1 from "./index.vue?vue&type=style&index=1&id=15250cdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15250cdc",
  null
  
)

export default component.exports